"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@ori-ui/mui-bundle/material/styles");
var _constants = require("../constants");
const styleOverrides = {
  root: {
    backgroundColor: 'transparent'
  },
  dotActive: ({
    theme
  }) => ({
    backgroundColor: theme.palette.default.dark,
    transform: 'scale(1.2)'
  }),
  dots: {
    alignItems: 'center'
  },
  dot: ({
    theme
  }) => ({
    transition: `transform ${_styles.duration.short}ms ${_styles.easing.easeInOut}, box-shadow ${_styles.duration.short}ms ${_styles.easing.easeInOut}, background-color ${_styles.duration.short}ms ${_styles.easing.easeInOut}`,
    willChange: 'transform, box-shadow, background-color',
    backgroundColor: theme.palette.grey[400],
    width: 10,
    height: 10,
    margin: theme.spacing(0, 1)
  }),
  positionStatic: ({
    theme
  }) => ({
    color: theme.palette.text.secondary,
    fontSize: theme.typography.body1.fontSize,
    fontWeight: _constants.font.fontWeightBold
  }),
  progress: ({
    theme
  }) => ({
    color: theme.palette.default.dark
  })
};
const defaultProps = {
  LinearProgressProps: {
    color: 'inherit'
  }
};
var _default = exports.default = {
  defaultProps,
  styleOverrides
};
